/**
 * locationDistance.js — PROD-655 (patient P2): ONE answer to "how far is this practice from where
 * the patient said they are", for the send flow (ShareScreen, "find a doctor").
 *
 * With the device position (the patient chose "Use my current location"), the distance is the
 * on-device haversine from that fix to the practice's geocoded coordinates — what the Doctors tab
 * computes (DoctorsScreen allDoctorsLive). Without coordinates on either side it is the ZIP-centroid
 * distance (utils/zipDistance), which is what the home ZIP and a typed ZIP use. Nothing here leaves
 * the device.
 *
 * @param {object} d             a doctor row (practice_lat / practice_lng / practice_zip)
 * @param {{coords?: {lat:number,lng:number}|null, zip?: string}} from
 * @returns {number|null} miles (one decimal for the haversine), or null when unknown
 */
import { haversineMiles } from './googleMaps'
import { getZipDistance } from './zipDistance'

export function doctorDistanceMiles(d, { coords = null, zip = '' } = {}) {
  if (coords && Number.isFinite(coords.lat) && Number.isFinite(coords.lng) && d && d.practice_lat != null && d.practice_lng != null) {
    const lat = Number(d.practice_lat)
    const lng = Number(d.practice_lng)
    if (Number.isFinite(lat) && Number.isFinite(lng)) return Math.round(haversineMiles(coords.lat, coords.lng, lat, lng) * 10) / 10
  }
  if (zip && d && d.practice_zip) return getZipDistance(zip, d.practice_zip)
  return null
}
